<!--
 * @Author: 汪俊洪
 * @Date: 2025-06-04 14:33:54
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2025-06-05 16:47:39
 * @Description:
-->
<template>
  <div class="wrap">
    <div class="content">
      <h2 class="title">立即加入</h2>
      <div class="sub-title">三步开启生态合作之旅</div>
      <div class="list">
        <div
          v-for="(item, index) in list"
          :key="index"
          :class="`item item${index + 1}`"
        >
          <h3 class="item-title">{{ item.title }}</h3>
          <div
            :style="{ 'margin-top': index2 === 0 ? '40px' : '60px' }"
            v-for="(item2, index2) in item.item"
            :class="`item-child item-${index + 1}-${index2 + 1}`"
            :key="index2"
          >
            <h3 class="item-sub-title">{{ item2.title }}</h3>
            <div class="item-des">
              {{ item2.des }}
            </div>
          </div>
          <div class="btn-wrap">
            <div class="btn" v-if="status.showTest" @click="setVisible">
              <span>免费体验</span>
              <i class="el-icon-arrow-right"></i>
            </div>
            <div class="btn" v-if="status.showApplyRecords" @click="setVisible">
              <span>申请记录</span>
              <i class="el-icon-arrow-right"></i>
            </div>
            <div class="btn" v-if="status.showWorkbench" @click="setVisible">
              <span>进入工作台</span>
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    status: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      list: [
        {
          title: '入驻条件',
          item: [
            {
              title: '企业资质',
              des: '具备工程服务相关营业执照、行业许可及专业团队'
            },
            {
              title: '服务能力',
              des: '可提供自动化工程、现场调试、技术专家等至少一项核心服务'
            },
            {
              title: '合规要求',
              des: '近三年无重大违法违规记录，信用记录良好'
            }
          ]
        },
        {
          title: '审核与反馈',
          item: [
            {
              title: '提交资料',
              des: '提交资料后，生态合作管理部将及时完成资质初审'
            },
            {
              title: '审核通过',
              des: '审核通过后，平台账号生效，可自主创建人员子账号并申请能力标签'
            },
            {
              title: '入驻成功',
              des: '入驻成功后，即可查看最新需求公告并参与接单'
            }
          ]
        }
      ]
    }
  },
  methods: {
    setVisible () {
      this.$emit('setVisible')
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap {
  padding: 100px 0 100px;
  height: 936px;
  background: #f7f8fd;
  .content {
    width: 1200px;
    margin: 0 auto;
  }
  .title {
    font-size: 40px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.8);
    text-align: center;
    margin: 0 0 0;
    line-height: 49px;
  }
  .sub-title {
    font-size: 20px;
    font-weight: 500;
    line-height: normal;
    text-align: center;
    color: rgba(0, 0, 0, 0.8);
    line-height: 27px;
    padding: 10px 0 50px;
  }
}
.list {
  display: flex;
  justify-content: space-between;
  .item {
    display: flex;
    flex-direction: column;
    width: 582px;
    height: 600px;
    border-radius: 16px;
    background: #ffffff;
    padding: 40px 40px;
    .item-title {
      font-size: 24px;
      font-weight: 500;
      line-height: 30px;
      color: rgba(0, 0, 0, 0.8);
      margin: 0;
    }

    .item-sub-title {
      font-size: 20px;
      font-weight: 500;
      line-height: 24px;
      color: rgba(0, 0, 0, 0.8);
      padding: 0 0 10px;
      margin: 0;
    }
    .item-des {
      font-size: 18px;
      color: rgba(0, 0, 0, 0.4);
    }
  }
}

.item1 {
  > .item-child {
    position: relative;
    padding-left: 54px;
    &::before {
      position: absolute;
      left: 0;
      top: 7px;
      display: block;
      content: '';
      width: 44px;
      height: 44px;
      border-radius: 50%;
      border: 2px solid rgba(42, 84, 209, 0.53);
      background: url('~@/assets/img/ecology/left_1.png') no-repeat;
      background-size: cover;
    }
    &.item-1-2::before {
      background: url('~@/assets/img/ecology/left_2.png') no-repeat;
      background-size: cover;
    }
    &.item-1-3::before {
      background: url('~@/assets/img/ecology/left_3.png') no-repeat;
      background-size: cover;
    }
  }
}

.item2 {
  position: relative;
  &::before {
    position: absolute;
    left: 62px;
    top: 155px;
    display: block;
    width: 2px;
    height: 260px;
    background: #d8d8d8;
    content: '';
  }
  > .item-child {
    position: relative;
    padding-left: 54px;
    &::before {
      position: absolute;
      left: 0;
      top: 7px;
      display: block;
      content: '';
      width: 44px;
      height: 44px;
      background: url('~@/assets/img/ecology/right_1.png') no-repeat;
    }
    &.item-2-2::before {
      background: url('~@/assets/img/ecology/right_2.png') no-repeat;
      background-size: cover;
    }
    &.item-2-3::before {
      background: url('~@/assets/img/ecology/right_3.png') no-repeat;
      background-size: cover;
    }
  }
}
.btn-wrap {
  flex: 1;
  display: flex;
  align-items: flex-end;
}
.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 213px;
  height: 45px;
  padding: 10px 0;
  border-radius: 4px;
  background: #2a54d1;
  font-size: 18px;
  font-weight: 500;
  text-align: center;
  color: #ffffff;
  cursor: pointer;

  .el-icon-arrow-right {
    font-size: 14px;
    margin-left: 10px;
  }

  &:hover {
    opacity: 0.8;
  }
}
</style>
